module.exports = __webpack_public_path__ + "b98b2ba13ca7f965fcf87427c3a5ab1b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-12.png
// module id = 2028
// module chunks = 0